/* eslint-disable max-len */
/* eslint-disable no-console */
import React, { useEffect, useState } from 'react';
import $ from 'jquery';
import { Box, Grid } from '@mui/material';
import UIGrid from '../uigrid';
import { resultsData, calculatedResultsData } from './resultsData';
import { argo_report } from './outputdata';

const DetailedResults = ({ data, recovery, product }) => {
  const [feedData] = useState(data.feed_ppm || null);
  const [brineData] = useState(data.waste_dict || null);
  const [updatedResultsData, setUpdatedResultsData] = useState(resultsData);
  const [argo_report_data, setArgoReportData] = useState(data?.calculation_results);

  useEffect(() => {
    // Update resultsData with new feed and brine values
    const updated = resultsData.map(item => {
      const feedValue = feedData?.[item.chemicalName]?.toFixed(2) || item.raw;
      let brineValue = brineData?.ppm_dict?.[recovery]?.[item.chemicalName]?.toFixed(2) || item.braine;
      if(item.chemicalName === 'ph'){
        brineValue = brineData?.ph_dict?.[recovery]?.toFixed(2) || item.braine;
      }
      if(item.chemicalName === 'tds'){
        brineValue = brineData?.tds_dict?.[recovery]?.toFixed(2) || item.braine;
      }
      if(item.chemicalName === 'CO2'){
        brineValue = brineData?.ppm_dict?.[recovery]?.CO2?.toFixed(2) || item.braine;
      }
      if(item.chemicalName === 'CCPP'){
        brineValue = brineData?.ccpp_dict?.[recovery]?.toFixed(2) || item.braine;
      }
      if(item.chemicalName === 'S&DI'){
        brineValue = brineData?.sdi_dict?.[recovery]?.toFixed(2) || item.braine;
      }
      if(item.chemicalName === 'Ionic Strength'){
        brineValue = brineData?.ionicstr_dict?.[recovery]?.toFixed(4) || item.braine;
      }

      return {
        ...item,
        raw: feedValue,
        braine: brineValue
      };
    });
    // argo_report_data = argo_report.ROHP_1[0]?.calculationResults || calculatedResultsData;

    setUpdatedResultsData(updated);
  }, []);
  const getSaturationIndex = (value, recoveryIndex) => {
    if (!value) return { key: '-', value: '-' };
    const lsi = value.LSI?.[recoveryIndex];
    if (lsi != null && lsi <= 3) {
      return { key: 'LSI', value: lsi?.toFixed(2) ?? '-' };
    }
    const sdi = value['S&DI']?.[recoveryIndex];
    return { key: 'S&DI', value: sdi?.toFixed(2) ?? '-' };
  };

  const getCCPPAndLimit = (ccppValue, product, saturationKey) => {
    const activeDualequationCCPP = JSON.parse(localStorage.getItem('Active_DualequationCCPP')) || {};
    if (activeDualequationCCPP?.[product] === 1) {
      const limitText =
        saturationKey === 'LSI'
          ? 'CCPP < 1000 or LSI < 3'
          : 'CCPP < 1000 or S&DI < 3';
      return {
        limit: limitText,
        ccpp: ccppValue != null ? ccppValue.toFixed(2) : '-'
      };
    }
    return { limit: '3', ccpp: '-' };
  };
  const recoveryIndex = recovery - 1;
  const calciumCarbonateData = argo_report_data?.['Calcium Carbonate'];
  const saturationInfo = getSaturationIndex(calciumCarbonateData, recoveryIndex);
  const { limit: caco3Limit, ccpp: ccppDisplay } =
    getCCPPAndLimit(calciumCarbonateData?.CCPP?.[recoveryIndex], product, saturationInfo.key);
  const activeDualequationCCPP = JSON.parse(localStorage.getItem('Active_DualequationCCPP')) || {};
  const isDualEq = activeDualequationCCPP?.[product] === 1;
  const caco3_Keys = Object.keys(argo_report_data?.['Calcium Carbonate'] || {});
  // Build CaCO3 row conditionally (only this row changes layout)
  const caCO3Row = isDualEq
    ? {
      Key: 'CaCO3',
      KeyText: 'Calcium Carbonate',
      // Column headers will be: CCPP | (LSI or S&DI) | Limit
      saturation: ccppDisplay ?? '-',              // CCPP value goes under second column
      limits: saturationInfo.value ?? '-',         // Saturation index value under third column
      max: caco3Limit ?? ' '                       // Limit text under fourth column
    }
    : {
      Key: 'CaCO3',
      KeyText: 'Calcium Carbonate',
      saturation: saturationInfo.value ?? '-',     // Saturation value (LSI or S&DI)
      limits: caco3Limit,                          // Limit text
      max: ccppDisplay ?? ' '                       // CCPP value (or '-')
    };

  const key_value = [
    caCO3Row,
    { Key: '-', KeyText: '-', saturation: 'Saturation', limits: 'Limit', max: '% of Max'},
    { Key: 'CaSO4', KeyText: 'Calcium Sulphate', saturation: argo_report_data?.Saturation?.[recovery]?.CaSO4 ?? '-', limits: argo_report_data?.Limits?.[product]?.CaSO4 ?? '-', max: argo_report_data?.['% of Max']?.[recovery]?.[product]?.CaSO4?.toFixed(2) ?? '-'},
    { Key: 'BaSO4', KeyText: 'Barium Sulphate', saturation: argo_report_data?.Saturation?.[recovery]?.BaSO4 ?? '-', limits: argo_report_data?.Limits?.[product]?.BaSO4 ?? '-', max: argo_report_data?.['% of Max']?.[recovery]?.[product]?.BaSO4?.toFixed(2) ?? '-'},
    { Key: 'SrSO4', KeyText: 'Strontium Sulphate', saturation: argo_report_data?.Saturation?.[recovery]?.SrSO4 ?? '-', limits: argo_report_data?.Limits?.[product]?.SrSO4 ?? '-', max: argo_report_data?.['% of Max']?.[recovery]?.[product]?.SrSO4?.toFixed(2) ?? '-'},
    { Key: 'CaF2', KeyText: 'Calcium Fluoride', saturation: argo_report_data?.Saturation?.[recovery]?.CaF2 ?? '-', limits: argo_report_data?.Limits?.[product]?.CaF2 ?? '-', max: argo_report_data?.['% of Max']?.[recovery]?.[product]?.CaF2?.toFixed(2) ?? '-'},
    { Key: 'CaHPO4', KeyText: 'Calcium Phosphate', saturation: argo_report_data?.Saturation?.[recovery]?.CaHPO4 ?? '-', limits: argo_report_data?.Limits?.[product]?.CaHPO4 ?? '-', max: argo_report_data?.['% of Max']?.[recovery]?.[product]?.CaHPO4?.toFixed(2) ?? '-'},
    { Key: '-', KeyText: '-', saturation: 'Brine Conc', limits: 'Limit', max: '% of Max'},
    { Key: 'Fe', KeyText: 'Iron', saturation: argo_report_data?.Saturation?.[recovery]?.Fe ?? '-', limits: argo_report_data?.Limits?.[product]?.Fe ?? '-', max: argo_report_data?.['% of Max']?.[recovery]?.[product]?.Fe?.toFixed(2) ?? '-'},
    { Key: 'Mn', KeyText: 'Manganese', saturation: argo_report_data?.Saturation?.[recovery]?.Mn ?? '-', limits: argo_report_data?.Limits?.[product]?.Mn ?? '-', max: argo_report_data?.['% of Max']?.[recovery]?.[product]?.Mn?.toFixed(2) ?? '-'},
    { Key: 'Al', KeyText: 'Aluminium', saturation: argo_report_data?.Saturation?.[recovery]?.Al ?? '-', limits: argo_report_data?.Limits?.[product]?.Al ?? '-', max: argo_report_data?.['% of Max']?.[recovery]?.[product]?.Al?.toFixed(2) ?? '-'},
    { Key: 'SiO2', KeyText: 'Silica', saturation: argo_report_data?.Saturation?.[recovery]?.SiO2 ?? '-', limits: argo_report_data?.Limits?.[product]?.SiO2 ?? '-', max: argo_report_data?.['% of Max']?.[recovery]?.[product]?.SiO2?.toFixed(2) ?? '-'}
  ];
  const properties = [
    { hdata: '', tag: 'Ion', disabled: true, datatype: 'text' },
    { hdata: 'Raw (ppm)', tag: 'raw', disabled: null, datatype: 'number' },
    { hdata: 'Brine (ppm)', tag: 'braine', disabled: null, datatype: 'number' },
    // { hdata: 'ppm as CaCO3', tag: 'ppmAsCaCO3', disabled: null, datatype: 'number' }
  ];
  const calculatedResultsProperties = isDualEq
    ? [
      { hdata: '', tag: 'Key', disabled: true, datatype: 'text' },
      { hdata: 'CCPP', tag: 'saturation', disabled: true, datatype: 'text' },                // second column header changed
      { hdata: saturationInfo.key ?? '-', tag: 'limits', disabled: true, datatype: 'text' }, // third column header is original saturation key
      { hdata: 'Limit', tag: 'max', disabled: true, datatype: 'text' }                       // fourth column header becomes Limit
    ]
    : [
      { hdata: '', tag: 'Key', disabled: true, datatype: 'text' },
      { hdata: saturationInfo.key ?? '-', tag: 'saturation', disabled: true, datatype: 'text' },
      { hdata: 'Limit', tag: 'limits', disabled: true, datatype: 'text' },
      { hdata: ' ', tag: 'max', disabled: true, datatype: 'text' }
    ];
  localStorage.setItem('Calcium_Carbonate_value', JSON.stringify({[saturationInfo.key]: saturationInfo.value, Limit: caco3Limit, [isDualEq ? 'CCPP' : '']: isDualEq ? ccppDisplay : ''}));
  useEffect(() => {
    $('.custom-calculatedResults-grid .row_2').addClass('highlightHeader');
    $('.custom-calculatedResults-grid .row_8').addClass('highlightHeader');
  }, []);
  return (
    <div>
      <Grid container spacing={2}>
        <Grid item xs={5} className="modal-background">
          <h4>Water Composition</h4>
          <Box
            className="custom-Results-grid"
            style={{
              height: 'auto',
              width: 'auto',
              marginRight:'20px'
            }}
          >
            <UIGrid
              data={updatedResultsData}
              properties={properties}
              // onblur={handleAfterEdit}
            />
          </Box>
        </Grid>
        <Grid item xs={7} className="modal-background">
          <h4>Saturation Index</h4>
          <Box
            className="custom-Results-grid custom-calculatedResults-grid"
            style={{
              height: 'auto',
              width: 'auto',
              marginRight:'20px'
            }}>
            <UIGrid
              data={key_value}
              properties={calculatedResultsProperties}
              // onblur={handleAfterEdit}
            />
          </Box>
        </Grid>
      </Grid>
    </div>
  );
};

export default DetailedResults;
